import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import app from '../../main' // import the instance
import checkResponse from '@/utils/checkResponse'
import parserFilters from '@/utils/parserFilters'
import parserSlug from '@/utils/parserSlug'
import qs from 'qs'; 

Vue.use(Vuex)

const state = {
  commissionsCatalog: {
    commissions: [],
    graphics: {
      commissionsPerMonth: [],
      commissionsPerSeller: [],
      salesPerSeller: [],
      topSalesCustomers: [],
      topSalesProducts: []
    }
  },
  paginationOpenCommissions: {
    currentPage: 1,
    perPage: 10,
    totalOpenCommissions: 0,
    totalPages: 0
  },
  paginationClosedCommissions: {
    currentPage: 1,
    perPage: 10,
    totalOpenCommissions: 0,
    totalPages: 0
  },
  filterParams: '',
  graphicsFilterParams: {}
}

const mutations = {
  SET_OPEN_COMMISSIONS_CATALOG (state, payload) {
    state.commissionsCatalog.commissions = payload['payload']['commissions']['data']
    state.paginationOpenCommissions = {
      currentPage: payload['payload']['commissions'].current_page,
      perPage: payload['payload']['commissions'].per_page,
      total: payload['payload']['commissions'].total,
      totalPages: payload['payload']['commissions'].last_page
    }
  },
  SET_CLOSED_COMMISSIONS_CATALOG (state, payload) {
    state.commissionsCatalog.commissions = payload['payload']['commissions']['data']
    state.paginationClosedCommissions = {
      currentPage: payload['payload']['commissions'].current_page,
      perPage: payload['payload']['commissions'].per_page,
      total: payload['payload']['commissions'].total,
      totalPages: payload['payload']['commissions'].last_page
    }    
  },
  SET_COMMISSIONS_GRAPHICS (state, payload) {
    state.commissionsCatalog.graphics.commissionsPerMonth = payload['payload']['statistics']['original']['commissionsPerMonth']
    state.commissionsCatalog.graphics.commissionsPerSeller = payload['payload']['statistics']['original']['commissionsPerSeller']
    state.commissionsCatalog.graphics.salesPerSeller = payload['payload']['statistics']['original']['salesPerSeller']
    state.commissionsCatalog.graphics.topSalesCustomers = payload['payload']['statistics']['original']['topSalesCustomers']
    state.commissionsCatalog.graphics.topSalesProducts = payload['payload']['statistics']['original']['topSalesProducts']
  },
  SET_FILTER_PARAMS (state, payload) {
    state.filterParams = payload
  },
  SET_GRAPHICS_FILTER_PARAMS (state, payload) {
    state.graphicsFilterParams = payload
  }
}

const actions = {
  async loadCatalogV2 ({ commit }, payload) {
    let url = parserSlug(payload.url)
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    const graphicsFilterString = qs.stringify(state.graphicsFilterParams);
    const filterString = state.filterParams ? `&${state.filterParams}` : '';
    try {
        const response = await axios.get(`v2/${url}?page=${payload.page}${filterString}&${graphicsFilterString}`);
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_OPEN_COMMISSIONS_CATALOG', { payload: response.data })
        commit('SET_CLOSED_COMMISSIONS_CATALOG', { payload: response.data })
        commit('SET_COMMISSIONS_GRAPHICS', { payload: response.data })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async updateCommission ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.put(`/commissions/${payload.id}`, payload);
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_ACCEPT_ALERT', { color: 'primary', title: 'strings.commissions', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  applyFilter ({ commit }, payload) {
    const filter = parserFilters(payload.filters)
    commit('SET_FILTER_PARAMS', filter)
  }, 
  applyGraphicsFilters ({ commit }, payload)  {
    commit('SET_GRAPHICS_FILTER_PARAMS', payload.filters)
  }
}

const getters = {
  commissionsCatalog: state => state.commissionsCatalog,
  paginationOpenCommissions: state => state.paginationOpenCommissions,
  paginationClosedCommissions: state => state.paginationClosedCommissions,
  filterParams: state => state.filterParams
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
